module.exports = __webpack_public_path__ + "img/404.e9835160.png";